/* Centralized, typed environment configuration */

const rawApiBaseUrl = (process.env.REACT_APP_API_BASE_URL || '').trim();
const rawTimeoutMs = (process.env.REACT_APP_HTTP_TIMEOUT_MS || '').trim();
const rawLogLevel = (process.env.REACT_APP_LOG_LEVEL || '').trim();

const isProd = process.env.NODE_ENV === 'production';
const isDev = !isProd;

function ensureTrailingSlashRemoved(url: string): string {
  return url.endsWith('/') ? url.slice(0, -1) : url;
}

function parseTimeoutMs(value: string | undefined, fallback: number): number {
  const parsed = value ? Number(value) : NaN;
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

if (!rawApiBaseUrl && isProd) {
  throw new Error('REACT_APP_API_BASE_URL is required in production builds');
}

const apiBaseUrl = rawApiBaseUrl ? ensureTrailingSlashRemoved(rawApiBaseUrl) : '';
const httpTimeoutMs = parseTimeoutMs(rawTimeoutMs, 10000);
const logLevel = rawLogLevel || (isProd ? 'warn' : 'debug');

export const config = {
  apiBaseUrl,
  httpTimeoutMs,
  logLevel,
  isProd,
  isDev,
} as const;

export type AppConfig = typeof config;
